import { render, staticRenderFns } from "./LoginSplitPage.vue?vue&type=template&id=10bcc005&scoped=true&"
import script from "./LoginSplitPage.vue?vue&type=script&lang=js&"
export * from "./LoginSplitPage.vue?vue&type=script&lang=js&"
import style0 from "./LoginSplitPage.vue?vue&type=style&index=0&id=10bcc005&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bcc005",
  null
  
)

export default component.exports